import { config } from '@uhg-abyss/web/tools/config';

import { useCustomQuery } from '../useCustomQuery';
import GET_PROVIDER_DIRECTORY from './getProviderDirectoryPdfs.graphql';

export const useGetProviderDirectories = (options) => {
  const [queryResult, queryAction] = useCustomQuery(GET_PROVIDER_DIRECTORY, {
    ...options,
    url: config('GRAPHQL_API_URL'),
    accessor: 'getProviderDirectory',
    requestPolicy: 'no-cache',
  });
  const parsedResult = {
    ...queryResult,
    data: {
      ...queryResult?.data?.getProviderDirectory,
    },
  };
  return [parsedResult, queryAction];
};
